<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Despesas</h5>

      <div class="d-flex align-items-center" style="gap: 40px;">
        <div class="form-check m-0 checkbox-compensacao-repasse">
          <input
            id="ocultar-compensacao-repasse"
            v-model="ocultarCompensacaoRepasse"
            class="form-check-input"
            type="checkbox"
            @change="carregarDespesas"
          />
          <label
            class="form-check-label texto-ocultar-compensacao"
            for="ocultar-compensacao-repasse"
          >
            Ocultar compensação no repasse
          </label>
        </div>

        <BButton
          v-if="hasPermission('adicionar_despesas')"
          variant="primary"
          class="d-flex align-items-center"
          @click="irParaCadastro"
        >
          <i class="bi bi-plus-circle-fill mr-2" title="Nova Despesa"></i>
        </BButton>
      </div>
    </div>

    <!-- Filtros -->
    <div class="mb-3">
      <div class="row g-2 align-items-end mb-2">
        <div class="col-12 col-md-6 col-lg-3">
          <select v-model="filters.tipo" @change="filtrar" class="form-select">
            <option value="">Plano de Contas: Todos</option>
            <option v-for="t in tipos" :key="t" :value="t">{{ t }}</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <select v-model="filters.pagamento" @change="filtrar" class="form-select">
            <option value="">Pagamento: Todos</option>
            <option value="hoje">Hoje</option>
            <option value="anteriores">Anteriores</option>
            <option value="futuros">Futuros</option>
            <option value="pendentes">Pendentes</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <input
            type="month"
            v-model="filters.mesAno"
            class="form-control"
            @change="filtrar"
            title="Filtrar por mês/ano do vencimento"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <select v-model="filters.forma" @change="filtrar" class="form-select">
            <option value="">Forma de Pagamento: Todos</option>
            <option v-for="f in formas" :key="f.id" :value="f.nome">{{ f.nome }}</option>
          </select>
        </div>
      </div>
      <div class="row g-2 align-items-end">
        <div class="col-12 col-md-6 col-lg-3">
          <input v-model="filters.valor" placeholder="Filtrar por valor: 0,00" aria-label="Filtrar por valor" class="form-control" @input="filtrar" />
        </div>
        <div class="col-12 col-md-6 col-lg">
          <input
            v-model="filters.descricao"
            placeholder="Filtrar descrição"
            class="form-control"
            @input="filtrar"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-auto d-flex justify-content-end">
          <BButton
            variant="secondary"
            @click="limparFiltros"
            class="d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
          </BButton>
        </div>
      </div>
    </div>

    <!-- Tabela -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>
            <button class="btn btn-link p-0" @click="sort('tipo')">
              Plano de Contas {{ arrow('tipo') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('valor_total_pago')">
              Total Pago {{ arrow('valor_total_pago') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_vencimento')">
              Vencimento {{ arrow('data_vencimento') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_pagamento')">
              Pagamento {{ arrow('data_pagamento') }}
            </button>
          </th>
          <!-- <th>
            <button class="btn btn-link p-0" @click="sort('data_recebimento')">
              Recebimento {{ arrow('data_recebimento') }}
            </button>
          </th> -->
          <th>
            <button class="btn btn-link p-0" @click="sort('forma_pagamento')">
              Forma de Pagamento {{ arrow('forma_pagamento') }}
            </button>
          </th>
          <th>Descrição</th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in despesas" :key="row.seq">
          <td>{{ row.seq }}</td>
          <td>
            <span v-if="row.tipo === 'Entradas da Loja'" class="text-success">
              {{ row.tipo }}
            </span>
            <span v-else>
              {{ row.tipo }}
            </span>
          </td>
          <td>{{ formatCurrency(row.valor_total_pago ?? row.valor) }}</td>
          <td>{{ formatDate(row.data_vencimento) }}</td>
          <td>
            <span v-if="row.data_pagamento">
              {{ formatDate(row.data_pagamento) }}
            </span>

            <span
              v-else-if="isCompensacaoNoRepasse(row)"
              class="text-muted"
            >
              Compensado
            </span>

            <span v-else class="text-danger">
              Pendente
            </span>
          </td>
          <!-- <td>
            <span v-if="row.data_recebimento">{{ formatDate(row.data_recebimento) }}</span>
            <span v-else class="text-danger">Pendente</span>
          </td> -->
          <td>{{ row.forma_pagamento }}</td>
          <td>{{ formatDescricaoTabela(row.descricao) }}</td>
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_despesas')"
              class="bi bi-eye-fill text-primary mx-2"
              @click="detalharRow(row)"
            ></i>
            <i
              v-if="hasPermission('alterar_despesas')"
              class="bi bi-pencil-fill text-warning mx-2"
              @click="editarDespesa(row)"
            ></i>
            <i
              v-if="hasPermission('excluir_despesas')"
              class="bi bi-trash-fill mx-2"
              :class="row.tipo === 'Entradas da Loja' ? 'text-muted disabled-trash' : 'text-danger'"
              :title="row.tipo === 'Entradas da Loja'
                ? 'Essa despesa deve ser removida em Entradas da Loja'
                : 'Excluir registro'"
              @click="onClickExcluir(row)"
              style="cursor: pointer;"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- 1. Resumo -->
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalRegistros }} registros
      </div>

      <!-- 2. Seletor de Itens por página -->
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limitePorPagina"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="paginaAtual = 1; carregarDespesas()"
        />
      </div>

      <!-- 3. Controle de página -->
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="paginaAtual"
          :per-page="limitePorPagina"
          :total-rows="totalRegistros"
          size="sm"
          limit="5"
          @input="carregarDespesas"
        />
      </div>
    </div>

    <!-- Modal de edição -->
    <EditarDespesas
      v-if="showEditModal"
      :id="editId"
      :origem="editOrigin" 
      @updated="onEditSuccess"
      @cancel="showEditModal = false"
    />

    <!-- Modal de exclusão -->
    <div v-if="showDeleteModal" class="modal-overlay">
      <div class="modal-container">
        <div class="modal-header">
          <h6>Excluir despesa</h6>
          <i class="bi bi-x-circle close-icon" @click="cancelarExclusao"></i>
        </div>

        <div class="modal-body">
          <p>
            Deseja realmente excluir a despesa
            <strong>{{ deleteRow?.descricao }}</strong>
            com vencimento em
            <strong>{{ formatDate(deleteRow?.data_vencimento) }}</strong>?
          </p>
          <p>Escolha uma opção:</p>

          <ul>
            <li>Excluir somente esta despesa;</li>
            <li>Excluir esta despesa e as futuras já programadas e ainda pendentes.</li>
          </ul>
        </div>

        <div class="modal-footer d-flex justify-content-end" style="gap: .5rem;">
          <button class="btn btn-secondary" @click="cancelarExclusao">
            Cancelar
          </button>
          <button class="btn btn-danger" @click="confirmExcluirSomenteEsta">
            Excluir somente esta despesa
          </button>
          <button class="btn btn-danger" @click="confirmExcluirComFuturas">
            Excluir esta e futuras pendentes
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from '@/services/axios';
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next';
import EditarDespesas from '@/components/modals/EditarDespesas.vue';
import globalUtils from '@/utils/globalUtils';

export default {
  name: 'ListarDespesas',
  components: { BButton, BPagination, BFormSelect, EditarDespesas },
  data() {
    return {
      despesas: [],
      formas: [],
      tipos: [], // receberá nomes de subcontas via API se necessário
      filters: { valor: '', pagamento: '', recebimento: '', tipo: '', forma: '', descricao: '', mesAno: '' },
      paginaAtual: 1,
      limitePorPagina: 10,
      totalRegistros: 0,
      pageOptions: [10, 15, 20, 25, 50],
      totalPaginas: 1,
      currentSort: { key: 'data_vencimento', order: 'asc' },
      showEditModal: false,
      editId: null,
      editOrigin: null,

      // NOVOS CAMPOS PARA EXCLUSÃO
      showDeleteModal: false,
      deleteRow: null,      // linha selecionada

      ocultarCompensacaoRepasse: true,
    };
  },
  methods: {
    async carregarFormas() {
      try {
        const res = await axios.get('/cadastros/formas-pagamento');
        this.formas = res.data;
      } catch (e) {
        console.error('Erro ao carregar formas:', e);
      }
    },
    sort(col) {
      if (this.currentSort.key === col) {
        this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort.key = col;
        this.currentSort.order = 'asc';
      }
      this.carregarDespesas();
    },
    arrow(col) {
      if (this.currentSort.key !== col) return '';
      return this.currentSort.order === 'asc' ? '▲' : '▼';
    },
    editarDespesa(row) {
      // Se você ainda quiser abrir a página completa quando existir despesa_id, remova as 2 linhas abaixo.
      this.editId = row.id;
      this.editOrigin = (row.tipo === 'Entradas da Loja') ? 'entradas' : 'despesas';
      this.showEditModal = true;
    },
    onEditSuccess() {
      this.showEditModal = false;
      this.carregarDespesas();
    },

    isCompensacaoNoRepasse(row) {
      return String(row?.forma_pagamento || '').trim().toLowerCase() === 'compensação no repasse';
    },    

    async carregarTipos() {
      try {
        const res = await axios.get('/financeiro/despesas-completas/tipos', {
          params: {
            pagamento: this.filters.pagamento || undefined,
            recebimento: this.filters.recebimento || undefined,
            forma: this.filters.forma || undefined,
            valor: this.filters.valor || undefined,
            descricao: this.filters.descricao || undefined,
            mesAno: this.filters.mesAno || undefined,     // NOVO
            ocultarCompensacaoRepasse: this.ocultarCompensacaoRepasse ? 'true' : undefined,
          }
        });
        this.tipos = res.data;
      } catch (e) {
        console.error('Erro ao carregar tipos de despesa:', e);
      }
    },

    async carregarDespesas() {
      try {
        const res = await axios.get('/financeiro/despesas-completas', {
          params: {
            page: this.paginaAtual,
            limit: this.limitePorPagina,
            sortBy: this.currentSort.key,
            order: this.currentSort.order,
            pagamento: this.filters.pagamento || undefined,
            recebimento: this.filters.recebimento || undefined,
            tipo: this.filters.tipo || undefined,
            forma: this.filters.forma || undefined,
            valor: this.filters.valor || undefined,
            descricao: this.filters.descricao || undefined,
            mesAno: this.filters.mesAno || undefined,     // NOVO
            ocultarCompensacaoRepasse: this.ocultarCompensacaoRepasse ? 'true' : undefined,
          },
        });
        const { data, totalPages, totalItems } = res.data;
        let linhas = Array.isArray(data) ? [...data] : [];

        this.despesas = linhas.map((item, i) => ({
          ...item,
          seq: i + 1 + (this.paginaAtual - 1) * this.limitePorPagina,
        }));
        this.totalPaginas   = totalPages;
        this.totalRegistros = totalItems;
      } catch (err) {
        console.error('Erro ao carregar despesas:', err);
      }
    },

    onClickExcluir(row) {
      if (row.tipo === 'Entradas da Loja') {
        // apenas ignora o clique (tooltip já explica)
        return;
      }
      this.deleteRow = row;
      this.showDeleteModal = true;
    },

    async excluir(id, modo = 'unico') {
      if (!id) return;

      const msg =
        modo === 'futuras'
          ? 'Confirmar exclusão desta despesa e das futuras já programadas e ainda pendentes?'
          : 'Confirmar exclusão apenas desta despesa?';

      const ok = window.confirm(msg);
      if (!ok) return;

      try {
        const params = {};
        if (modo === 'futuras') {
          params.modo = 'futuras';
        }

        await axios.delete(`/financeiro/despesas-completas/${id}`, { params });

        this.showDeleteModal = false;
        this.deleteRow = null;

        await this.carregarDespesas();
        console.log('✅ Registro(s) excluído(s) com sucesso.');
      } catch (err) {
        console.error('Erro ao excluir despesa:', err);
        alert('Não foi possível excluir. Verifique dependências e tente novamente.');
      }
    },

    formatDate(d) {
      return globalUtils.formatarData(d) || '—';
    },
    formatCurrency(v) {
      return v != null
        ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : '—';
    },
    formatDescricaoTabela(descricao) {
      const texto = String(descricao || '').trim();
      if (!texto) return '—';

      // Remove tudo a partir de " - Origem: ..."
      const semOrigem = texto.split(' - Origem: ')[0].trim();

      // Para descrições do tipo:
      // "Taxa GETNET - Autorização 248992 - 02/02/2026"
      // retorna só:
      // "Taxa GETNET - Autorização 248992"
      const matchTaxa = semOrigem.match(/^(Taxa\s.+?\s-\sAutorização\s.+?)(\s-\s\d{2}\/\d{2}\/\d{4})?$/i);
      if (matchTaxa) {
        return matchTaxa[1].trim();
      }

      return semOrigem;
    },
    alterarLimite() {
      this.paginaAtual = 1;
      this.carregarDespesas();
    },
    async filtrar() {
      this.paginaAtual = 1;
      await this.carregarTipos();
      this.carregarDespesas();
    },
    async limparFiltros() {
      this.filters = { valor: '', pagamento: '', recebimento: '', tipo: '', forma: '', descricao: '', mesAno: '' }; // NOVO
      this.paginaAtual = 1;
      await this.carregarTipos();
      this.carregarDespesas();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarDespesas();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.carregarDespesas();
      }
    },
    detalharRow(row) {
      const origem = (row.tipo === 'Entradas da Loja') ? 'entradas' : 'despesas';
      this.$router.push(`/financeiro/despesas/${row.id}/detalhar?origem=${origem}`);
    },
    irParaCadastro() {
      this.$router.push('/financeiro/despesas/novo');
    },

    confirmExcluirSomenteEsta() {
      if (!this.deleteRow) return;
      this.excluir(this.deleteRow.id, 'unico');
    },

    confirmExcluirComFuturas() {
      if (!this.deleteRow) return;
      this.excluir(this.deleteRow.id, 'futuras');
    },

    cancelarExclusao() {
      this.showDeleteModal = false;
      this.deleteRow = null;
    },

  },

    computed: {
    startRow() {
      return (this.paginaAtual - 1) * this.limitePorPagina + 1;
    },
    endRow() {
      return Math.min(this.paginaAtual * this.limitePorPagina, this.totalRegistros);
    }
  },

  watch: {
    paginaAtual() {
      this.carregarDespesas();   // dispara ao mudar de página
    }
  },

  async mounted() {
    await this.fetchPermissions();
    await this.carregarFormas();
    await this.carregarTipos();
    this.carregarDespesas();
  },
};
</script>

<style scoped>

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-container {
  background: #fff;
  border-radius: .5rem;
  max-width: 600px;
  width: 100%;
  padding: 1rem 1.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .75rem;
}

.modal-body {
  margin-bottom: 1rem;
}

.modal-footer button + button {
  margin-left: .25rem;
}

.close-icon {
  cursor: pointer;
}

.checkbox-compensacao-repasse {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0;
}

.checkbox-compensacao-repasse .form-check-input {
  position: static;
  margin: 0;
  float: none;
  flex: 0 0 auto;
}

.checkbox-compensacao-repasse .form-check-label {
  margin: 0;
}

.texto-ocultar-compensacao {
  font-size: 0.8rem;
  white-space: nowrap;
  line-height: 2;
  font-weight: normal;
}

/* .texto-ocultar-compensacao {
  font-size: 0.85rem;
  margin-left: 0.35rem;
  margin-right: 2rem;
  white-space: nowrap;
} */

</style>